<div class="bg">
  <div class="header ml-4">
    <img src="assets/images/login-header.png" alt="" class="img-fluid" />
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 tab-view">
        <img src="assets/images/register-image.png" alt="" class="img-fluid" />
      </div>
      <div class="col-lg-6 col-md-6 tab-view">
        <div class="login-title">
          <h2>Register</h2>
        </div>
        <div>
          <form action="" [formGroup]="registerForm">
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Incubator Name <span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  placeholder="Enter Incubator Name"
                  formControlName="name"
                  [ngClass]="{
                    'is-invalid': add.name.touched && add.name.errors
                  }"
                />
                <mat-error *ngIf="add.name.touched && add.name.errors">
                  <span *ngIf="add.name.errors.required"
                    >Incubator Name is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Email ID <span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  formControlName="email"
                  placeholder="Enter Email ID"
                  oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                  type="text"
                  (keydown.space)="$event.preventDefault()"
                  [ngClass]="{
                    'is-invalid': add.email.touched && add.email.errors
                  }"
                />
                <mat-error *ngIf="add.email.touched && add.email.errors">
                  <span *ngIf="add.email.errors.required"
                    >Email ID is required</span
                  >
                  <span *ngIf="add.email.errors.email">
                    <i class="fas fa-exclamation-triangle"></i>
                    Invalid Email
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label>Mobile<span class="text-danger">*</span></mat-label>
                <input
                  matInput
                  type="text"
                  maxlength="10"
                  minlength="10"
                  oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                  placeholder="Enter Mobile Number"
                  formControlName="phone"
                  [ngClass]="{
                    'is-invalid': add.phone.touched && add.phone.errors
                  }"
                />
                <mat-error *ngIf="add.phone.touched && add.phone.errors">
                  <span *ngIf="add.phone.errors.required"
                    >Mobile Number is required</span
                  >
                  <span *ngIf="add.phone.errors.pattern">
                    <i class="fas fa-exclamation-triangle"></i>
                    Mobile Number is Invalid
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Registration Type
                  <span class="text-danger">*</span></mat-label
                >
                <mat-select
                  (selectionChange)="selectRegistrationType($event.value)"
                  formControlName="incubatorRegistrationType"
                  [ngClass]="{
                    'is-invalid':
                      add.incubatorRegistrationType.touched &&
                      add.incubatorRegistrationType.errors
                  }"
                >
                  <mat-option value="Society"> Society </mat-option>
                  <mat-option value="Section 8 Company">
                    Section 8 Company
                  </mat-option>
                  <mat-option value="Trust"> Trust </mat-option>
                  <mat-option value="Other"> Other </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    add.incubatorRegistrationType.touched &&
                    add.incubatorRegistrationType.errors
                  "
                >
                  <span *ngIf="add.incubatorRegistrationType.errors.required"
                    >Registration Type is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="showOtherRegType == true">
              <div class="form-rows">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label
                    >Registration Other Type Details
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Registration Other Type Details"
                    formControlName="incubatorRegistrationTypeOther"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorRegistrationTypeOther.touched &&
                        add.incubatorRegistrationTypeOther.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorRegistrationTypeOther.touched &&
                      add.incubatorRegistrationTypeOther.errors
                    "
                  >
                    <span
                      *ngIf="add.incubatorRegistrationTypeOther.errors.required"
                      >Registration Other Type Details is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Short Description
                  <span class="text-danger">*</span></mat-label
                >
                <textarea
                  matInput
                  placeholder="Enter Short Description"
                  formControlName="incubatorRegDesc"
                  cols="30"
                  rows="3"
                  type="text"
                  #message
                  minlength="250"
                  [ngClass]="{
                    'is-invalid':
                      add.incubatorRegDesc.touched &&
                      add.incubatorRegDesc.errors
                  }"
                ></textarea>
                <mat-hint matSuffix>{{ message.value.length }}</mat-hint>
                <mat-error
                  *ngIf="
                    add.incubatorRegDesc.touched && add.incubatorRegDesc.errors
                  "
                >
                  <span *ngIf="add.incubatorRegDesc.errors.required"
                    >Short Description is required</span
                  >
                  <span *ngIf="add.incubatorRegDesc.errors.minlength"
                    >Minimun 250 length is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-rows">
              <label for="input-file-id" class="md-button md-raised md-primary">
                Upload Registration Document <span class="text-danger"> *</span
                ><ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName }}</span>
                <input
                  class="d-none"
                  id="input-file-id"
                  type="file"
                  (change)="fileUpload($event)"
                />
              </label>
              <mat-error
                class="font-12"
                *ngIf="
                  add.incubatorRegFileName.touched &&
                  add.incubatorRegFileName.errors
                "
              >
                <span *ngIf="add.incubatorRegFileName.errors.required"
                  >Document is required</span
                >
              </mat-error>
              <div class="text-center">
                <span class="noti-span c-white"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="disName">
                    <i
                      class="fas fa-trash delete-i"
                      (click)="deleteImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
              </div>
            </div>
          </form>
        </div>
        <div class="text-center">
          <button class="login-btn" (click)="cancelReg()">Cancel</button>
          <button class="login-btn" (click)="registerAdmin()">Register</button>
          <div id="RegisterModal" class="modal">
            <div class="modal-content text-center">
              <div class="text-center">
                <img
                  style="width: 100px"
                  src="/assets/images/registration-1.png"
                  alt=""
                />
              </div>
              <p class="text-center" style="padding: 20px; font-size: 20px">
                <span style="font-size: 24px; font-weight: 500"
                  >Thank you for Registering as Incubator.</span
                ><br />
                <span style="font-size: 17px; color: gray"
                  >Your application is under review. The credentials will be
                  shared through email once application is approved.</span
                >
              </p>
              <div class="text-center">
                <button class="incubatorBtn" (click)="closeModal()">OK</button>
              </div>
            </div>
          </div>
        </div>
        <div class="account text-center mt-3">
          <span
            >Already have an account?
            <a href="" routerLink="/login"><b>Login</b> </a>
          </span>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 mobile-view">
        <div class="login-title">
          <h2>Register</h2>
        </div>
        <div>
          <form action="" [formGroup]="registerForm">
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >User Name <span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  placeholder="Enter User Name"
                  formControlName="name"
                  [ngClass]="{
                    'is-invalid': add.name.touched && add.name.errors
                  }"
                />
                <mat-error *ngIf="add.name.touched && add.name.errors">
                  <span *ngIf="add.name.errors.required"
                    >User Name is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Email Id<span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  placeholder="Enter Email"
                  formControlName="email"
                  [ngClass]="{
                    'is-invalid': add.email.touched && add.email.errors
                  }"
                />
                <mat-error *ngIf="add.email.touched && add.email.errors">
                  <span *ngIf="add.email.errors.required"
                    >User Name is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Mobile Number<span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  placeholder="Enter Mobile"
                  formControlName="phone"
                  type="text"
                  maxlength="10"
                  minlength="10"
                  oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                  [ngClass]="{
                    'is-invalid': add.phone.touched && add.phone.errors
                  }"
                />
                <mat-error *ngIf="add.phone.touched && add.phone.errors">
                  <span *ngIf="add.phone.errors.required"
                    >Mobile Numbers is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Registration Type
                  <span class="text-danger">*</span></mat-label
                >
                <mat-select
                  (selectionChange)="selectRegistrationType($event.value)"
                  formControlName="incubatorRegistrationType"
                  [ngClass]="{
                    'is-invalid':
                      add.incubatorRegistrationType.touched &&
                      add.incubatorRegistrationType.errors
                  }"
                >
                  <mat-option value="Society"> Society </mat-option>
                  <mat-option value="Section 8 Company">
                    Section 8 Company
                  </mat-option>
                  <mat-option value="Trust"> Trust </mat-option>
                  <mat-option value="Other"> Other </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    add.incubatorRegistrationType.touched &&
                    add.incubatorRegistrationType.errors
                  "
                >
                  <span *ngIf="add.incubatorRegistrationType.errors.required"
                    >Registration Type is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="showOtherRegType == true">
              <div class="form-rows">
                <mat-form-field class="material-full-width" appearance="fill">
                  <mat-label
                    >Registration Other Type Details
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Registration Other Type Details"
                    formControlName="incubatorRegistrationTypeOther"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorRegistrationTypeOther.touched &&
                        add.incubatorRegistrationTypeOther.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorRegistrationTypeOther.touched &&
                      add.incubatorRegistrationTypeOther.errors
                    "
                  >
                    <span
                      *ngIf="add.incubatorRegistrationTypeOther.errors.required"
                      >Registration Other Type Details is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Short Description
                  <span class="text-danger">*</span></mat-label
                >
                <textarea
                  matInput
                  placeholder="Enter Short Description"
                  formControlName="incubatorRegDesc"
                  cols="30"
                  rows="3"
                  type="text"
                  #message
                  minlength="250"
                  [ngClass]="{
                    'is-invalid':
                      add.incubatorRegDesc.touched &&
                      add.incubatorRegDesc.errors
                  }"
                ></textarea>
                <mat-hint matSuffix>{{ message.value.length }}</mat-hint>
                <mat-error
                  *ngIf="
                    add.incubatorRegDesc.touched && add.incubatorRegDesc.errors
                  "
                >
                  <span *ngIf="add.incubatorRegDesc.errors.required"
                    >Short Description is required</span
                  >
                  <span *ngIf="add.incubatorRegDesc.errors.minlength"
                    >Minimun 250 length is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-rows">
              <label for="input-file-id" class="md-button md-raised md-primary">
                Upload Registration Document <span class="text-danger"> *</span
                ><ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName }}</span>
                <input
                  class="d-none"
                  id="input-file-id"
                  type="file"
                  (change)="fileUpload($event)"
                />
              </label>
              <mat-error
                class="font-12"
                *ngIf="
                  add.incubatorRegFileName.touched &&
                  add.incubatorRegFileName.errors
                "
              >
                <span *ngIf="add.incubatorRegFileName.errors.required"
                  >Document is required</span
                >
              </mat-error>
              <div class="text-center">
                <span class="noti-span c-white"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="disName">
                    <i
                      class="fas fa-trash delete-i"
                      (click)="deleteImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
              </div>
            </div>
          </form>
        </div>
        <div class="text-center">
          <button class="login-btn" (click)="cancelReg()">Cancel</button>
          <button class="login-btn" (click)="registerAdmin()">Register</button>
        </div>
        <div class="account text-center mt-3">
          <span
            >Already have an account?
            <a href="" routerLink="/login"><b>Login</b> </a>
          </span>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 mobile-view">
        <img src="assets/images/register-image.png" alt="" class="img-fluid" />
      </div>
    </div>
  </div>
</div>
